import { call, put, takeEvery } from 'redux-saga/effects';
import * as api from 'src/state/api';
import { notificationsManager } from 'src/state/Notifications';
import SignActions from './actions';
import ActionTypes from './types';
import SigningCaseActions from 'src/state/SigningCaseDetails/actions';

type IsSignatureSuccessfulParams = ReturnType<typeof SignActions.signDocument>;
function* isSignatureSuccessful(params: IsSignatureSuccessfulParams) {
  try {
    yield put(SignActions.signDocumentRequest());

    const isSuccessful = yield call(
      api.isSignatureSuccessful,
      params.payload.signatureId,
      params.payload.signingCaseId,
      params.payload.contractingPartyId
    );

    yield put(SigningCaseActions.fetchSignDocumentUpdate());
    yield put(SignActions.signDocumentSuccess(isSuccessful.data.data));
  } catch (e) {
    yield put(SignActions.signDocumentFailure());
    yield put(notificationsManager.addNotification(e));
  }
}

export function* watch() {
  yield takeEvery(ActionTypes.SIGN_DOCUMENT, isSignatureSuccessful);
}
